import type { ReactNode } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { theme } from '@styles/theme';
import { GlobalStyle } from '@styles/global';

interface ThemeProviderProps {
  children: ReactNode;
}

/**
 * Provider que injeta o tema da marca em toda a árvore de styled-components
 * e aplica os estilos globais.
 */
export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyle />
      {children}
    </StyledThemeProvider>
  );
}
